import type { JSONSchema7Definition } from 'json-schema';
import _schema from '../../external/data/schema.json';

export const schema = _schema as JSONSchema7Definition;
export type { CompanyRecord, GenericRecord } from '../../external/data/src/types/records';
